import { Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl } from "@angular/forms";
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogConfig as MatDialogConfig } from "@angular/material/legacy-dialog";
import { MatStepper } from "@angular/material/stepper";
import { FileValidator, FileInputComponent } from "ngx-material-file-input";
import * as _ from "lodash";
import { first } from "rxjs/operators";
import { Subscription } from "rxjs";

import { AppGlobals } from "../../app.globals";
import { IUser } from "../../_models";
import { HousingService, AlertService, LookupsService, ScholasticPeriodsService, UserService, MediaWatcherService } from "../../_services";
import { UnSavedChangesDialogComponent } from "../../_components/unSavedChangesDialog/unSavedChangesDialog.component";
import { ConfirmationDialogComponent } from "../../_components/confirmationDialog/confirmationDialog.component";

@Component({
    templateUrl: "housingApplicationDialog.component.html",
    styleUrls: ["housingApplicationDialog.component.css"]
})
export class HousingApplicationDialogComponent implements OnInit, OnDestroy {
    isEditable = true;

    personalDetailsFormGroup: UntypedFormGroup;
    lifestyleFormGroup: UntypedFormGroup;
    buildingsFormGroup: UntypedFormGroup;
    reviewFormGroup: UntypedFormGroup;
    currentUser: IUser;
    applicationSteps: null;
    semesters: any[];
    scholasticPeriods = [];
    applicationId: number = 0;
    applicationRowversion: string;
    currentScholasticPeriod: any;
    selectedStepIndex: null;
    isApplicationRecurring: boolean = false;
    buildingOptions = [];
    housingApplications = [];
    housingPrograms = [];
    currentSemester = null;
    existingApplicationScholasticPeriods: number[];
    existingApplicationHousingPrograms: number[];
    allowEdit: boolean;
    isMobile = false;
    mediaWatcherSubscription: Subscription;
    isHousingProgramApplication = false;
    isSubmitted = false;
    applicationHousingProgramId = null;
    applicationScholasticPeriodId = null;
    isDSStudent = false;
    isReturningStudent = false;
    allBuildingOptions = [];

    // 1 MB
    readonly maxSize = 1048576;

    medicalNeedsFileName: string = null;
    medicalNeedsFileType: string = null;
    medicalNeedsAttachmentId: number = null;

    @ViewChild("medicalNeedsAttachment") medicalNeedsAttachmentInput: FileInputComponent;
    @ViewChild("stepper", { static: true }) stepper: MatStepper;

    //lifestyle form
    lifestyleQuestions = null;
    allLifestyleQuestions = null;
    lifestyleDetails = [];

    //buildings form
    buildingDetailsRowversion: string;
    buildingPreference1 = null;
    buildingPreference2 = null;
    buildingPreference3 = null;

    constructor(private dialogRef: MatDialogRef<HousingApplicationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: any,
        private formBuilder: UntypedFormBuilder,
        public dialog: MatDialog,
        private appGlobals: AppGlobals,
        private alertService: AlertService,
        private lookupsService: LookupsService,
        private housingService: HousingService,
        private scholasticPeriodsService: ScholasticPeriodsService,
        private userService: UserService,
        private mediaWatcherService: MediaWatcherService) {
        this.currentUser = data.currentUser;
        this.applicationId = data.applicationId;
        this.selectedStepIndex = data.selectedStepIndex;
        this.housingApplications = data.housingApplications;
        this.housingPrograms = data.housingPrograms;
        this.existingApplicationScholasticPeriods = data.existingApplicationScholasticPeriods;
        this.existingApplicationHousingPrograms = data.existingApplicationHousingPrograms;
        this.allowEdit = data.allowEdit;
        this.isHousingProgramApplication = data.isHousingProgramApplication;
        this.isSubmitted = data.isSubmitted;

        this.isReturningStudent = this.housingApplications.length > 1;

        this.isDSStudent =
            (this.currentUser.schoolId === 1 && this.currentUser.funnelId === 4427 || this.currentUser.funnelId === 4431 || this.currentUser.funnelId === 4432 || this.currentUser.funnelId === 4433 || this.currentUser.funnelId === 4434 || this.currentUser.funnelId === 4435) || (this.currentUser.schoolId === 2 && this.currentUser.funnelId === 11674);
    }

    ngOnDestroy() {
        this.mediaWatcherSubscription.unsubscribe();
    }

    ngOnInit() {
        //this.googleAnalyticsService.logPageView("/housingApplication");

        this.stepper.selectedIndex = this.selectedStepIndex;

        this.mediaWatcherSubscription = this.mediaWatcherService.isTabletLarge.subscribe(isMobile => {
            this.isMobile = isMobile;
        });

        this.initializeForm();

        this.onChanges();

        //lifestyle questions
        this.lookupsService.getHousingApplicationLifestyleQuestions()
            .pipe(first())
            .subscribe((response: any) => {
                this.allLifestyleQuestions = response; //_.filter(response, { "isActive": true }) as any;

                //for (let i = 0; i < this.lifestyleQuestions.length; i++) {
                //    this.lifestyleFormGroup.addControl(`answer${this.lifestyleQuestions[i].id}`, new UntypedFormControl(this.lifestyleQuestions[i].answer));
                //    this.reviewFormGroup.addControl(`answer${this.lifestyleQuestions[i].id}`, new UntypedFormControl(this.lifestyleQuestions[i].answer));

                //    if (!this.allowEdit) {
                //        this.lifestyleFormGroup.controls[`answer${this.lifestyleQuestions[i].id}`].disable();
                //    }
                //}

                //semester
                this.lookupsService.getSemesters()
                    .pipe(first())
                    .subscribe((semesters: any) => {
                        this.scholasticPeriodsService.getCurrentSemester(this.currentUser.schoolId)
                            .pipe(first())
                            .subscribe((currentSemester: any) => {
                                this.currentSemester = currentSemester;

                                if (this.isHousingProgramApplication) {
                                    this.housingPrograms = this.housingPrograms.filter(f => {
                                        return (this.currentUser.programCodes && this.currentUser.programCodes.indexOf(f.code) !== -1) || (this.currentUser.hasProgramCodeWithRequiredAdmissions && f.providerId === this.currentUser.providerId) || (this.currentUser.hasAdmissionsForProgram && f.isOpenForAdmissions) || (this.existingApplicationHousingPrograms.length > 0 && this.existingApplicationHousingPrograms.indexOf(f.id) !== -1);
                                    });

                                    _.forEach(this.housingPrograms, f => {
                                        const housingProgram = {
                                            id: this.scholasticPeriods.length + 1,
                                            semesterId: f.scholasticPeriodId,
                                            housingProgramId: f.id,
                                            title: f.description,
                                            schoolId: f.schoolId,
                                            checkInDate: f.checkInDate,
                                            checkOutDate: f.checkOutDate,
                                            isActive: f.isActive,
                                            isWaitlistEnabled: f.isWaitlistEnabled
                                        };

                                        this.scholasticPeriods.push(housingProgram);
                                    });
                                }

                                this.housingApplications = _.filter(this.housingApplications, f => {
                                    return (this.applicationId === 0 ? f.scholasticPeriod.schoolId === this.currentUser.schoolId : true) && _.minBy(f.housingApplicationCheckInDates, "checkInDate") >= this.currentSemester.startDate;
                                });

                                //show semesters for which a housing application exists from this semester onwards
                                this.semesters = _.orderBy(_.filter(semesters, f => {
                                    return f.schoolId === this.currentUser.schoolId && _.find(this.housingApplications, { "scholasticPeriodId": f.id });
                                }), "startDate") as any;

                                if (!this.isHousingProgramApplication || this.currentUser.hasAdmissionsForProgram || this.currentUser.hasProgramCodeWithRequiredAdmissions) {
                                    _.forEach(this.semesters, (s: any) => {
                                        var housingApplication = _.find(this.housingApplications, { "scholasticPeriodId": s.id }) as any;

                                        var housingApplicationCheckInDate: any = null;

                                        if (this.currentUser.providerId)
                                            housingApplicationCheckInDate = _.find(housingApplication.housingApplicationCheckInDates, (c: any) => {
                                                if (c.housingApplicationProviderCheckInDates.length > 0)
                                                    return c;

                                                return null;
                                            });

                                        if (!housingApplicationCheckInDate && this.currentUser.funnelId)
                                            housingApplicationCheckInDate = _.find(housingApplication.housingApplicationCheckInDates, (c: any) => {
                                                if (c.housingApplicationFunnelCheckInDates.length > 0)
                                                    return c;

                                                return null;
                                            });

                                        s.checkInDate = housingApplicationCheckInDate ? housingApplicationCheckInDate.checkInDate : (_.minBy(housingApplication.housingApplicationCheckInDates, "checkInDate") as any).checkInDate;
                                        s.checkOutDate = housingApplication.checkOutDate;
                                        s.isActive = housingApplication.isActive;
                                        s.isWaitlistEnabled = housingApplication.isWaitlistEnabled;
                                    });

                                    _.forEach(this.semesters, s => {
                                        const semester = {
                                            id: this.scholasticPeriods.length + 1,
                                            semesterId: s.id,
                                            housingProgramId: null,
                                            title: s.title,
                                            schoolId: s.schoolId,
                                            checkInDate: s.checkInDate,
                                            checkOutDate: s.checkOutDate,
                                            isActive: s.isActive,
                                            isWaitlistEnabled: s.isWaitlistEnabled
                                        };

                                        this.scholasticPeriods.push(semester);
                                    });

                                    this.scholasticPeriods = _.orderBy(this.scholasticPeriods, ["checkInDate", "schoolId", "housingProgramId"], ["desc", "asc", "desc"]);
                                }

                                _.forEach(this.scholasticPeriods, s => {
                                    s.scholasticPeriodStartDate = semesters.find(f => f.id === s.semesterId).startDate;
                                });

                                if (this.applicationId !== 0) {
                                    //get application details
                                    this.housingService.getApplication(this.applicationId)
                                        .pipe(first())
                                        .subscribe((result: any) => {
                                            if (result) {
                                                this.applicationRowversion = result.rowversion;
                                                this.isApplicationRecurring = result.isRecurring;
                                                this.applicationHousingProgramId = result.housingProgramId;
                                                this.applicationScholasticPeriodId = result.scholasticPeriodId;

                                                this.personalDetailsFormGroup.get("isPartOfExtendedContract").setValue(result.isPartOfExtendedContract, {emitEvent: false});
                                                this.reviewFormGroup.get("isPartOfExtendedContract").setValue(result.isPartOfExtendedContract);

                                                if (!result.housingProgramId)
                                                    this.personalDetailsFormGroup.get("scholasticPeriodId").setValue(this.scholasticPeriods.find(f => f.semesterId === result.scholasticPeriodId).id);
                                                else
                                                    this.personalDetailsFormGroup.get("scholasticPeriodId").setValue(this.scholasticPeriods.find(f => f.housingProgramId === result.housingProgramId).id);

                                                this.personalDetailsFormGroup.get("medicalNeedsDetails").setValue(result.medicalNeedsDetails);
                                                this.personalDetailsFormGroup.get("lifestyleAdditionalDetails").setValue(result.lifestyleAdditionalDetails);

                                                this.medicalNeedsFileName = result.fileName;
                                                this.medicalNeedsFileType = result.fileType;
                                                this.medicalNeedsAttachmentId = result.medicalNeedsAttachmentId;

                                                if (result.fileName) {
                                                    this.personalDetailsFormGroup.get("medicalNeedsAttachment").setValidators([FileValidator.maxContentSize(this.maxSize)]);
                                                    this.personalDetailsFormGroup.get("medicalNeedsAttachment").updateValueAndValidity();
                                                }

                                                //lifestyle information
                                                if (result.housingStudentApplicationLifestylePreferences && result.housingStudentApplicationLifestylePreferences.length > 0) {
                                                    this.lifestyleDetails = _.orderBy(result.housingStudentApplicationLifestylePreferences, "housingApplicationLifestyleQuestionId");

                                                    //this.lookupsService.getHousingApplicationLifestyleQuestions()
                                                    //    .pipe(first())
                                                    //    .subscribe((response: any) => {
                                                    this.lifestyleQuestions = this.allLifestyleQuestions.filter(f => _.map(this.lifestyleDetails, "housingApplicationLifestyleQuestionId").indexOf(f.id) !== -1) as any;

                                                    _.forEach(this.lifestyleDetails, f => {
                                                        var currentAnswer = _.find(this.lifestyleQuestions, { "id": f.housingApplicationLifestyleQuestionId }) as any;

                                                        this.lifestyleFormGroup.addControl(`answer${currentAnswer.id}`, new UntypedFormControl(f.isPositiveAnswer));
                                                        this.reviewFormGroup.addControl(`answer${currentAnswer.id}`, new UntypedFormControl(f.isPositiveAnswer));

                                                        if (!this.allowEdit) {
                                                            this.lifestyleFormGroup.controls[`answer${currentAnswer.id}`].disable();
                                                        }

                                                        // this.lifestyleFormGroup.controls[`answer${currentAnswer.id}`].updateValueAndValidity();
                                                        //this.lifestyleFormGroup.controls[`answer${f.id}`].setValue(f.isPositiveAnswer);
                                                    });
                                                    //});
                                                } else {
                                                    //lifestyle questions
                                                    //this.lookupsService.getHousingApplicationLifestyleQuestions()
                                                    //    .pipe(first())
                                                    //    .subscribe((response: any) => {
                                                    this.lifestyleQuestions = _.filter(this.allLifestyleQuestions, { "isActive": true }) as any;

                                                    for (let i = 0; i < this.lifestyleQuestions.length; i++) {
                                                        this.lifestyleFormGroup.addControl(`answer${this.lifestyleQuestions[i].id}`, new UntypedFormControl(this.lifestyleQuestions[i].answer));
                                                        this.reviewFormGroup.addControl(`answer${this.lifestyleQuestions[i].id}`, new UntypedFormControl(this.lifestyleQuestions[i].answer));

                                                        if (!this.allowEdit) {
                                                            this.lifestyleFormGroup.controls[`answer${this.lifestyleQuestions[i].id}`].disable();
                                                        }
                                                    }
                                                    //});
                                                }

                                                //buildings information
                                                if (result.housingStudentApplicationBuildingPreferences && result.housingStudentApplicationBuildingPreferences.length > 0) {
                                                    this.buildingsFormGroup.get("buildingsAdditionalDetails").setValue(result.buildingsAdditionalDetails);
                                                    this.buildingPreference1 = _.find(result.housingStudentApplicationBuildingPreferences, { "priority": 1 }) as any;
                                                    this.buildingPreference2 = _.find(result.housingStudentApplicationBuildingPreferences, { "priority": 2 }) as any;
                                                    this.buildingPreference3 = _.find(result.housingStudentApplicationBuildingPreferences, { "priority": 3 }) as any;
                                                }
                                            }
                                        });
                                } else {
                                    //lifestyle questions
                                    //this.lookupsService.getHousingApplicationLifestyleQuestions()
                                    //    .pipe(first())
                                    //    .subscribe((response: any) => {
                                    this.lifestyleQuestions = _.filter(this.allLifestyleQuestions, { "isActive": true }) as any;

                                    for (let i = 0; i < this.allLifestyleQuestions.length; i++) {
                                        if (this.lifestyleQuestions[i]) {
                                            this.lifestyleFormGroup.addControl(`answer${this.lifestyleQuestions[i].id}`, new UntypedFormControl(this.lifestyleQuestions[i].answer));
                                            this.reviewFormGroup.addControl(`answer${this.lifestyleQuestions[i].id}`, new UntypedFormControl(this.lifestyleQuestions[i].answer));

                                            if (!this.allowEdit) {
                                                this.lifestyleFormGroup.controls[`answer${this.lifestyleQuestions[i].id}`].disable();
                                            }
                                        }
                                    }

                                    this.housingService.getStudentSpecialNeedsDetails(this.currentUser.id)
                                        .pipe(first())
                                        .subscribe((result: any) => {
                                            if (result) {
                                                this.medicalNeedsFileName = result.medicalNeedsFileName;
                                                this.medicalNeedsFileType = result.medicalNeedsFileType;
                                                this.medicalNeedsAttachmentId = result.medicalNeedsAttachmentId;
                                                this.personalDetailsFormGroup.get("medicalNeedsDetails").setValue(result.medicalNeedsDetails);
                                                this.personalDetailsFormGroup.get("lifestyleAdditionalDetails").setValue(result.lifeStyleAdditionalDetails);
                                            }
                                        });
                                    //});
                                }
                            });
                    });
            });
    }

    initializeForm() {
        this.personalDetailsFormGroup = this.formBuilder.group({
            scholasticPeriodId: [{ value: "", disabled: !this.allowEdit }, Validators.required],
            //housingProgramId: [{ value: "", disabled: !this.allowEdit || !this.isHousingProgramApplication }, Validators.required],
            medicalNeedsDetails: [{ value: null, disabled: !this.allowEdit }],
            lifestyleAdditionalDetails: [{ value: null, disabled: !this.allowEdit }],
            medicalNeedsAttachment: [{ value: "", disabled: true }, [Validators.required, FileValidator.maxContentSize(this.maxSize)]],
            isPartOfExtendedContract: [{ value: false, disabled: true }]
        });

        this.lifestyleFormGroup = this.formBuilder.group({
        });

        this.buildingsFormGroup = this.formBuilder.group({
            buildingsAdditionalDetails: [{ value: null, disabled: !this.allowEdit }],
            buildingPreference1: [{ value: null, disabled: !this.allowEdit }],
            buildingPreference2: [{ value: null, disabled: true }],
            buildingPreference3: [{ value: null, disabled: true }]
        });

        this.reviewFormGroup = this.formBuilder.group({
            scholasticPeriodId: [{ value: "", disabled: true }],
            isPartOfExtendedContract: [{ value: false, disabled: true }],
            //housingProgramId: [{ value: "", disabled: true }],
            medicalNeedsDetails: [{ value: null, disabled: true }],
            lifestyleAdditionalDetails: [{ value: null, disabled: true }],
            buildingsAdditionalDetails: [{ value: null, disabled: true }],
            buildingPreference1: [{ value: null, disabled: true }],
            buildingPreference2: [{ value: null, disabled: true }],
            buildingPreference3: [{ value: null, disabled: true }],
            //consent: [{ value: (this.allowEdit && !this.isSubmitted ? "" : true), disabled: !this.allowEdit || this.isSubmitted }, Validators.requiredTrue],
            confirmation: [{ value: (this.allowEdit && !this.isSubmitted ? "" : true), disabled: !this.allowEdit || this.isSubmitted }, Validators.requiredTrue]
        });
    }

    onChanges() {
        this.personalDetailsFormGroup.get("scholasticPeriodId").valueChanges
            .subscribe(selectedScholasticPeriodId => {
                var scholasticPeriod = _.find(this.scholasticPeriods, { "id": selectedScholasticPeriodId });

                //if scholastic period chosen application deadline is expired, then show a message
                var housingApplication;

                if (!scholasticPeriod.housingProgramId) {
                    housingApplication = _.find(this.housingApplications, { "scholasticPeriodId": scholasticPeriod.semesterId }) as any;

                    _.remove(this.existingApplicationScholasticPeriods, f => { return f === scholasticPeriod.semesterId });
                } else {
                    housingApplication = _.find(this.housingPrograms, { "id": scholasticPeriod.housingProgramId }) as any;

                    _.remove(this.existingApplicationHousingPrograms, f => { return f === scholasticPeriod.housingProgramId });
                }

                this.reviewFormControls.scholasticPeriodId.setValue(selectedScholasticPeriodId);

                const today = new Date();
                const applicationDeadline = new Date(housingApplication.applicationDeadline);

                if (this.allowEdit) {
                    if (housingApplication.isWaitlistEnabled)
                        this.alertService.showMessage(`Due to the high volume of JCU Housing requests, we have reached the full capacity in all our housing options for ${scholasticPeriod.title}. Your application will be placed on a waiting list even if it is submitted before the deadline. Should any spaces become available, the Housing Office will reach out to you immediately for confirmation and you will be asked to submit a deposit or a full payment, depending on the date of the confirmation.`, "Housing Application", this.appGlobals.alertMessageTypes.warning, 6000);
                    else {
                        if (today.getTime() > applicationDeadline.getTime() && scholasticPeriod)
                            this.alertService.showMessage(`Please be aware that the application deadline for Housing for ${scholasticPeriod.title} has passed. Students applying after the deadline will be placed in the remaining available housing options.`, "Housing Application", this.appGlobals.alertMessageTypes.warning, 6000);
                    }

                    if ((this.applicationId === 0 || !this.personalDetailsFormControls.isPartOfExtendedContract.value || !this.isSubmitted) && (housingApplication.isExtendedContract && (housingApplication.isExtendedContractForReturningStudents) || (!housingApplication.isExtendedContractForReturningStudents && !this.isReturningStudent)))
                        this.personalDetailsFormGroup.get("isPartOfExtendedContract").enable({emitEvent: false});
                    else
                        this.personalDetailsFormGroup.get("isPartOfExtendedContract").disable({emitEvent: false});
                }

                this.getBuildingOptions(scholasticPeriod);
            });

        //this.personalDetailsFormGroup.get("housingProgramId").valueChanges
        //    .subscribe(selectedHousingProgramId => {
        //        //if semester chosen application deadline is expired, then show a message
        //        var housingProgram = _.find(this.housingPrograms, { "id": selectedHousingProgramId }) as any;
        //        //var scholasticPeriod = _.find(this.semesters, { "id": selectedScholasticPeriodId });

        //        const today = new Date();
        //        const applicationDeadline = new Date(housingProgram.applicationDeadline);

        //        if (this.allowEdit && today.getTime() > applicationDeadline.getTime())
        //            this.alertService.showMessage(`Please be aware that the application deadline for Housing for ${housingProgram.description} has passed. Students applying after the deadline will be placed in the remaining available housing options.`, "Housing Application", this.appGlobals.alertMessageTypes.warning, 6000);

        //        this.reviewFormControls.housingProgramId.setValue(selectedHousingProgramId);

        //        _.remove(this.existingApplicationHousingPrograms, f => { return f === selectedHousingProgramId });

        //        //get building options
        //        //change to cater for housing programs
        //        this.housingService.getBuildingOptions(this.currentUser.id, null, selectedHousingProgramId)
        //            .pipe(first())
        //            .subscribe((options: any) => {
        //                this.buildingOptions = options;

        //                if (this.buildingPreference1 && (this.buildingDetailsFormControls.buildingPreference1.value === undefined || this.buildingDetailsFormControls.buildingPreference1.value === null)) {
        //                    const buildingOption = _.find(this.buildingOptions, f => {
        //                        return (this.buildingPreference1.housingBuildingId ? f.housingBuildingId === this.buildingPreference1.housingBuildingId : f.housingBuildingCategoryId === this.buildingPreference1.housingBuildingCategoryId) && f.housingRoomTypeId === this.buildingPreference1.housingRoomTypeId;
        //                    });

        //                    if (buildingOption)
        //                        this.buildingsFormGroup.get("buildingPreference1").setValue(buildingOption.id);
        //                }

        //                if (this.buildingPreference2 && (this.buildingDetailsFormControls.buildingPreference2.value === undefined || this.buildingDetailsFormControls.buildingPreference2.value === null)) {
        //                    const buildingOption = _.find(this.buildingOptions, f => {
        //                        return (this.buildingPreference2.housingBuildingId ? f.housingBuildingId === this.buildingPreference2.housingBuildingId : f.housingBuildingCategoryId === this.buildingPreference2.housingBuildingCategoryId) && f.housingRoomTypeId === this.buildingPreference2.housingRoomTypeId;
        //                    });

        //                    if (buildingOption)
        //                        this.buildingsFormGroup.get("buildingPreference2").setValue(buildingOption.id);
        //                }

        //                if (this.buildingPreference3 && (this.buildingDetailsFormControls.buildingPreference3.value === undefined || this.buildingDetailsFormControls.buildingPreference3.value === null)) {
        //                    const buildingOption = _.find(this.buildingOptions, f => {
        //                        return (this.buildingPreference3.housingBuildingId ? f.housingBuildingId === this.buildingPreference3.housingBuildingId : f.housingBuildingCategoryId === this.buildingPreference3.housingBuildingCategoryId) && f.housingRoomTypeId === this.buildingPreference3.housingRoomTypeId;
        //                    });

        //                    if (buildingOption)
        //                        this.buildingsFormGroup.get("buildingPreference3").setValue(buildingOption.id);
        //                }
        //            });
        //    });

        this.personalDetailsFormGroup.get("medicalNeedsDetails").valueChanges
            .subscribe(data => {
                if (!data || data.length === 0) {
                    this.medicalNeedsFileName = null;
                    this.medicalNeedsFileType = null;
                    this.medicalNeedsAttachmentId = null;

                    this.personalDetailsFormGroup.get("medicalNeedsAttachment").reset();
                    this.personalDetailsFormGroup.get("medicalNeedsAttachment").disable();
                    this.personalDetailsFormGroup.get("medicalNeedsAttachment").setValidators(null);
                } else {
                    if (this.allowEdit)
                        this.personalDetailsFormGroup.get("medicalNeedsAttachment").enable();

                    if (!this.medicalNeedsFileName)
                        this.personalDetailsFormGroup.get("medicalNeedsAttachment").setValidators([Validators.required, FileValidator.maxContentSize(this.maxSize)]);
                    else
                        this.personalDetailsFormGroup.get("medicalNeedsAttachment").setValidators([FileValidator.maxContentSize(this.maxSize)]);
                }

                this.personalDetailsFormGroup.get("medicalNeedsAttachment").updateValueAndValidity();
            });

        this.personalDetailsFormGroup.get("isPartOfExtendedContract").valueChanges
            .subscribe(isPartOfExtendedContract => {
                this.buildingOptions = _.cloneDeep(this.allBuildingOptions);

                if (this.personalDetailsFormControls.isPartOfExtendedContract.value)
                    this.buildingOptions = this.buildingOptions.filter(f => f.housingBuildingName.indexOf("Neighborhood ") !== -1);

                this.reviewFormControls.isPartOfExtendedContract.setValue(isPartOfExtendedContract);

                if (isPartOfExtendedContract)
                    this.showExtendedContractDialog();
            });

        this.buildingsFormGroup.get("buildingPreference1").valueChanges
            .subscribe(data => {
                if (data) {
                    if (this.buildingDetailsFormControls.buildingPreference2.value === data)
                        this.buildingsFormGroup.get("buildingPreference2").setValue(null, { emitEvent: false });

                    if (this.buildingDetailsFormControls.buildingPreference3.value === data)
                        this.buildingsFormGroup.get("buildingPreference3").setValue(null, { emitEvent: false });
                }

                if (this.buildingOptions.length > 1 && this.allowEdit)
                    this.buildingsFormGroup.get("buildingPreference2").enable({ emitEvent: false });

                this.reviewFormControls.buildingPreference1.setValue(data);
            });

        this.buildingsFormGroup.get("buildingPreference2").valueChanges
            .subscribe(data => {
                if (data) {
                    if (this.buildingDetailsFormControls.buildingPreference1.value === data)
                        this.buildingsFormGroup.get("buildingPreference1").setValue(null, { emitEvent: false });

                    if (this.buildingDetailsFormControls.buildingPreference3.value === data)
                        this.buildingsFormGroup.get("buildingPreference3").setValue(null, { emitEvent: false });
                }

                if (this.buildingOptions.length > 2 && this.allowEdit)
                    this.buildingsFormGroup.get("buildingPreference3").enable({ emitEvent: false });

                this.reviewFormControls.buildingPreference2.setValue(data);
            });

        this.buildingsFormGroup.get("buildingPreference3").valueChanges
            .subscribe(data => {
                if (data) {
                    if (this.buildingDetailsFormControls.buildingPreference1.value === data)
                        this.buildingsFormGroup.get("buildingPreference1").setValue(null, { emitEvent: false });

                    if (this.buildingDetailsFormControls.buildingPreference2.value === data)
                        this.buildingsFormGroup.get("buildingPreference2").setValue(null, { emitEvent: false });
                }

                this.reviewFormControls.buildingPreference3.setValue(data);
            });
    }

    get personalDetailsFormControls() { return this.personalDetailsFormGroup.controls as any; }

    get lifestyleDetailsFormControls() { return this.lifestyleFormGroup.controls as any; }

    get buildingDetailsFormControls() { return this.buildingsFormGroup.controls as any; }

    get reviewFormControls() { return this.reviewFormGroup.controls as any; }

    getBuildingOptions(scholasticPeriod: any) {
        //get building options
        //change to cater for housing programs
        this.housingService.getBuildingOptions(this.currentUser.id, !scholasticPeriod.housingProgramId ? scholasticPeriod.semesterId : null, scholasticPeriod.housingProgramId)
            .pipe(first())
            .subscribe((options: any) => {
                this.allBuildingOptions = options;
                this.buildingOptions = options;

                if (this.personalDetailsFormControls.isPartOfExtendedContract.value)
                    this.buildingOptions = this.buildingOptions.filter(f => f.housingBuildingName.indexOf("Neighborhood ") !== -1);

                if (this.buildingPreference1 && (this.buildingDetailsFormControls.buildingPreference1.value === undefined || this.buildingDetailsFormControls.buildingPreference1.value === null)) {
                    const buildingOption = _.find(this.buildingOptions, f => {
                        return (this.buildingPreference1.housingBuildingId ? f.housingBuildingId === this.buildingPreference1.housingBuildingId : f.housingBuildingCategoryId === this.buildingPreference1.housingBuildingCategoryId) && f.housingRoomTypeId === this.buildingPreference1.housingRoomTypeId;
                    });

                    if (buildingOption) {
                        this.buildingsFormGroup.get("buildingPreference1").setValue(buildingOption.id, { emitEvent: false });
                        this.reviewFormGroup.get("buildingPreference1").setValue(buildingOption.id, { emitEvent: false });
                    }
                }

                if (this.buildingPreference2 && (this.buildingDetailsFormControls.buildingPreference2.value === undefined || this.buildingDetailsFormControls.buildingPreference2.value === null)) {
                    const buildingOption = _.find(this.buildingOptions, f => {
                        return (this.buildingPreference2.housingBuildingId ? f.housingBuildingId === this.buildingPreference2.housingBuildingId : f.housingBuildingCategoryId === this.buildingPreference2.housingBuildingCategoryId) && f.housingRoomTypeId === this.buildingPreference2.housingRoomTypeId;
                    });

                    if (buildingOption) {
                        this.buildingsFormGroup.get("buildingPreference2").setValue(buildingOption.id, { emitEvent: false });
                        this.reviewFormGroup.get("buildingPreference2").setValue(buildingOption.id, { emitEvent: false });
                    }
                }

                if (this.buildingPreference3 && (this.buildingDetailsFormControls.buildingPreference3.value === undefined || this.buildingDetailsFormControls.buildingPreference3.value === null)) {
                    const buildingOption = _.find(this.buildingOptions, f => {
                        return (this.buildingPreference3.housingBuildingId ? f.housingBuildingId === this.buildingPreference3.housingBuildingId : f.housingBuildingCategoryId === this.buildingPreference3.housingBuildingCategoryId) && f.housingRoomTypeId === this.buildingPreference3.housingRoomTypeId;
                    });

                    if (buildingOption) {
                        this.buildingsFormGroup.get("buildingPreference3").setValue(buildingOption.id, { emitEvent: false });
                        this.reviewFormGroup.get("buildingPreference3").setValue(buildingOption.id, { emitEvent: false });
                    }
                }
            });
    }

    showExtendedContractDialog() {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.closeOnNavigation = true;
        dialogConfig.width = "45%";
        dialogConfig.height = "auto";
        dialogConfig.panelClass = "confirmation-dialog-container";
        dialogConfig.data =
        {
            title: "Housing Extended Contract",
            content: `I acknowledge that I have read and understood the information about the <a href="https://myjcu.johncabot.edu/Extended_Housing_2025.pdf" target="_blank">JCU Extended Housing Contract</a> </br> </br> By checking this box, I confirm and understand that I am applying for the JCU Extended Housing Contract from Fall through Spring, including Winter Break. Upon submitting my Fall application, I will receive Housing Confirmation emails for Fall, Winter Break, and Spring Housing applications`,
            rejectedReason: null,
            required: false,
            showSendRejectedEmail: false,
            rejectedEmailText: null
        };

        const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(result => {
            if (result !== "confirm") {
                this.personalDetailsFormGroup.get("isPartOfExtendedContract").setValue(null, { emitEvent: false });
            }
        });
    }

    personalDetailsCustomValidation() {
        if (this.personalDetailsFormControls.medicalNeedsAttachment.value && _.find(this.personalDetailsFormControls.medicalNeedsAttachment.value.files, (f: File) => f.type !== "application/vnd.openxmlformats-officedocument.wordprocessingml.document" && f.type !== "application/pdf" && f.type !== "image/jpeg" && f.type !== "image/jpg" && f.type !== "image/png")) {
            this.alertService.showMessage("Only pdf, word documents, jpg and png files are allowed.", "Housing Application", this.appGlobals.alertMessageTypes.error);

            return false;
        }

        return true;
    }

    savePersonalDetails(stepper: MatStepper, submitBtn: HTMLButtonElement) {
        // stop here if form is invalid
        if (this.personalDetailsFormGroup.invalid || !this.personalDetailsCustomValidation()) {
            if (this.personalDetailsFormControls.medicalNeedsAttachment.invalid) {
                this.personalDetailsFormControls.medicalNeedsAttachment.markAsTouched({ onlySelf: true });
            }

            return;
        }

        //if there where any changes...update the backend
        if (this.personalDetailsFormGroup.dirty) {
            setTimeout(() => {
                submitBtn.disabled = true;
            }, 0);

            const scholasticPeriod = this.scholasticPeriods.find(f => f.id === this.personalDetailsFormControls.scholasticPeriodId.value);

            const personalDetailsModel = {
                id: this.applicationId,
                studentRegistrationId: this.currentUser.id,
                housingStudentApplicationStatusId: 0,
                scholasticPeriodId: scholasticPeriod.semesterId,
                housingProgramId: scholasticPeriod.housingProgramId,
                isWaitlisted: scholasticPeriod.isWaitlistEnabled,
                medicalNeedsDetails: !this.personalDetailsFormControls.medicalNeedsDetails.value || !this.personalDetailsFormControls.medicalNeedsDetails.value.trim() ? null : this.personalDetailsFormControls.medicalNeedsDetails.value.trim(),
                lifestyleAdditionalDetails: !this.personalDetailsFormControls.lifestyleAdditionalDetails.value || !this.personalDetailsFormControls.lifestyleAdditionalDetails.value.trim() ? null : this.personalDetailsFormControls.lifestyleAdditionalDetails.value.trim(),
                fileName: this.personalDetailsFormControls.medicalNeedsAttachment.value ? this.personalDetailsFormControls.medicalNeedsAttachment.value.files[0].name : this.medicalNeedsFileName,
                fileType: this.personalDetailsFormControls.medicalNeedsAttachment.value ? this.personalDetailsFormControls.medicalNeedsAttachment.value.files[0].type : this.medicalNeedsFileType,
                medicalNeedsAttachmentId: this.medicalNeedsAttachmentId,
                isPartOfExtendedContract: this.personalDetailsFormControls.isPartOfExtendedContract.value ? this.personalDetailsFormControls.isPartOfExtendedContract.value : false,
                rowversion: this.applicationRowversion
            };

            const saveModel = new FormData();

            saveModel.append("personalDetailsModel", JSON.stringify(personalDetailsModel));

            if (this.personalDetailsFormControls.medicalNeedsAttachment.value)
                saveModel.append("medicalNeedsAttachment", this.personalDetailsFormControls.medicalNeedsAttachment.value.files[0], this.personalDetailsFormControls.medicalNeedsAttachment.value.files[0].name);

            this.housingService.insertOrUpdateHousingApplicationPersonalDetails(saveModel)
                .pipe(first())
                .subscribe((result: any) => {
                    this.applicationId = result.id;
                    this.applicationRowversion = result.rowversion;
                    this.isApplicationRecurring = result.isRecurring;
                    this.medicalNeedsFileName = result.fileName;
                    this.medicalNeedsFileType = result.fileType;
                    this.medicalNeedsAttachmentId = result.medicalNeedsAttachmentId;

                    if (this.medicalNeedsAttachmentInput) {
                        this.medicalNeedsAttachmentInput.clear();
                        this.personalDetailsFormControls.medicalNeedsAttachment.markAsPristine();
                        this.personalDetailsFormControls.medicalNeedsAttachment.markAsUntouched();
                        this.personalDetailsFormControls.medicalNeedsAttachment.setValidators([FileValidator.maxContentSize(this.maxSize)]);
                        this.personalDetailsFormControls.medicalNeedsAttachment.updateValueAndValidity();
                    }

                    this.personalDetailsFormGroup.markAsPristine();

                    stepper.next();
                });
        } else {
            stepper.next();
        }
    }

    saveLifestyleDetails(stepper: MatStepper, submitBtn: HTMLButtonElement) {
        // stop here if form is invalid
        if (this.lifestyleFormGroup.invalid) {
            return;
        }

        //if there where any changes...update the backend
        if (this.lifestyleFormGroup.dirty || this.lifestyleDetails.length === 0) {
            setTimeout(() => {
                submitBtn.disabled = true;
            }, 0);

            const lifeStyleQuestionsList = [];

            _.forEach(this.lifestyleQuestions, f => {
                var currentLifestyleQuestionDetails = _.find(this.lifestyleDetails, { "housingApplicationLifestyleQuestionId": f.id });

                const lifeStyleQuestionAnswer = {
                    id: currentLifestyleQuestionDetails ? currentLifestyleQuestionDetails.id : 0,
                    housingApplicationLifestyleQuestionId: f.id,
                    isPositiveAnswer: this.lifestyleFormGroup.controls[`answer${f.id}`].value ? this.lifestyleFormGroup.controls[`answer${f.id}`].value : false,
                    rowversion: currentLifestyleQuestionDetails ? currentLifestyleQuestionDetails.rowversion : null
                };

                lifeStyleQuestionsList.push((lifeStyleQuestionAnswer) as any);
            });

            const lifestyleDetailsModel = {
                housingStudentApplicationId: this.applicationId,
                applicationRowversion: this.applicationRowversion,
                housingStudentApplicationLifestylePreferences: lifeStyleQuestionsList
            };

            this.housingService.insertOrUpdateHousingApplicationLifestyleDetails(lifestyleDetailsModel)
                .pipe(first())
                .subscribe((result: any) => {
                    this.applicationRowversion = result.applicationRowversion;

                    this.lifestyleDetails = result.housingStudentApplicationLifestylePreferences;

                    this.lifestyleFormGroup.markAsPristine();

                    stepper.next();
                });
        } else
            stepper.next();
    }

    saveBuildingDetails(stepper: MatStepper, submitBtn: HTMLButtonElement) {
        // stop here if form is invalid
        if (this.buildingsFormGroup.invalid) {
            return;
        }

        //if there where any changes...update the backend
        if (this.buildingsFormGroup.dirty) {
            setTimeout(() => {
                submitBtn.disabled = true;
            }, 0);

            const buildingPreferencesList = [];

            if (!this.buildingDetailsFormControls.buildingPreference1.disabled && (this.buildingDetailsFormControls.buildingPreference1.value === 0 || this.buildingDetailsFormControls.buildingPreference1.value)) {
                const chosenBuildingOption = _.find(this.buildingOptions, { "id": this.buildingDetailsFormControls.buildingPreference1.value }) as any;

                const buildingPreference = {
                    id: this.buildingPreference1 ? this.buildingPreference1.id : 0,
                    housingBuildingId: chosenBuildingOption.housingBuildingId,
                    housingBuildingCategoryId: chosenBuildingOption.housingBuildingCategoryId,
                    housingRoomTypeId: chosenBuildingOption.housingRoomTypeId,
                    priority: 1,
                    rowversion: null
                };

                buildingPreferencesList.push((buildingPreference) as any);
            }

            if (!this.buildingDetailsFormControls.buildingPreference2.disabled && (this.buildingDetailsFormControls.buildingPreference2.value === 0 || this.buildingDetailsFormControls.buildingPreference2.value)) {
                const chosenBuildingOption = _.find(this.buildingOptions, { "id": this.buildingDetailsFormControls.buildingPreference2.value }) as any;

                const buildingPreference = {
                    id: this.buildingPreference2 ? this.buildingPreference2.id : 0,
                    housingBuildingId: chosenBuildingOption.housingBuildingId,
                    housingBuildingCategoryId: chosenBuildingOption.housingBuildingCategoryId,
                    housingRoomTypeId: chosenBuildingOption.housingRoomTypeId,
                    priority: 2,
                    rowversion: null
                };

                buildingPreferencesList.push((buildingPreference) as any);
            }

            if (!this.buildingDetailsFormControls.buildingPreference3.disabled && (this.buildingDetailsFormControls.buildingPreference3.value === 0 || this.buildingDetailsFormControls.buildingPreference3.value)) {
                const chosenBuildingOption = _.find(this.buildingOptions, { "id": this.buildingDetailsFormControls.buildingPreference3.value }) as any;

                const buildingPreference = {
                    id: this.buildingPreference3 ? this.buildingPreference3.id : 0,
                    housingBuildingId: chosenBuildingOption.housingBuildingId,
                    housingBuildingCategoryId: chosenBuildingOption.housingBuildingCategoryId,
                    housingRoomTypeId: chosenBuildingOption.housingRoomTypeId,
                    priority: 3,
                    rowversion: null
                };

                buildingPreferencesList.push((buildingPreference) as any);
            }

            const buildingDetailsModel = {
                housingStudentApplicationId: this.applicationId,
                applicationRowversion: this.applicationRowversion,
                buildingsAdditionalDetails: !this.buildingDetailsFormControls.buildingsAdditionalDetails.value || !this.buildingDetailsFormControls.buildingsAdditionalDetails.value.trim() ? null : this.buildingDetailsFormControls.buildingsAdditionalDetails.value.trim(),
                housingStudentApplicationBuildingPreferences: buildingPreferencesList
            };

            this.housingService.insertOrUpdateHousingApplicationBuildingsDetails(buildingDetailsModel)
                .pipe(first())
                .subscribe((result: any) => {
                    this.applicationRowversion = result.applicationRowversion;

                    this.buildingPreference1 = result.housingStudentApplicationBuildingPreferences.find((f: any) => f.priority === 1);

                    this.buildingPreference2 = result.housingStudentApplicationBuildingPreferences.find((f: any) => f.priority === 2);

                    this.buildingPreference3 = result.housingStudentApplicationBuildingPreferences.find((f: any) => f.priority === 3);

                    if (this.buildingPreference1 == undefined || this.buildingPreference1 === null)
                        this.buildingDetailsFormControls.buildingPreference1.reset();

                    if (this.buildingPreference2 == undefined || this.buildingPreference2 === null)
                        this.buildingDetailsFormControls.buildingPreference2.reset();

                    if (this.buildingPreference3 == undefined || this.buildingPreference3 === null)
                        this.buildingDetailsFormControls.buildingPreference3.reset();

                    this.buildingsFormGroup.markAsPristine();

                    stepper.next();
                });
        } else
            stepper.next();
    }

    saveReviewDetails(submitBtn: HTMLButtonElement) {
        // stop here if form is invalid
        if (this.reviewFormGroup.invalid) {
            return;
        }

        if (this.reviewFormGroup.dirty) {
            setTimeout(() => {
                submitBtn.disabled = true;
            }, 0);

            const saveModel = {
                housingStudentApplicationId: this.applicationId,
                rowversion: this.applicationRowversion
            }

            this.housingService.submitApplication(saveModel)
                .pipe(first())
                .subscribe(() => {
                    this.alertService.showMessage("Application Successfully Submitted.", "Housing Application", this.appGlobals.alertMessageTypes.success);

                    this.dialogRef.close();
                });
        }
    }

    openDocument(medicalNeedsAttachmentId: number) {
        this.userService.openAttachment(medicalNeedsAttachmentId)
            .pipe(first())
            .subscribe((response: any) => {
                const file = new Blob([response], { type: this.medicalNeedsFileType });
                var fileUrl = URL.createObjectURL(file);
                window.open(fileUrl);
            });
    }

    close() {
        if (this.personalDetailsFormGroup.dirty || this.lifestyleFormGroup.dirty || this.buildingsFormGroup.dirty || this.reviewFormGroup.dirty) {
            //show unsaved changes dialog
            const dialogConfig = new MatDialogConfig();

            dialogConfig.disableClose = true;
            dialogConfig.autoFocus = true;
            dialogConfig.closeOnNavigation = true;
            dialogConfig.width = this.isMobile ? "60vw" : "30vw";
            dialogConfig.height = "auto";
            dialogConfig.panelClass = "unSavedChanges-dialog-container";

            const dialogRef = this.dialog.open(UnSavedChangesDialogComponent, dialogConfig);

            dialogRef.afterClosed().subscribe(result => {
                if (result === "confirm") {
                    this.dialogRef.close();
                }
            });
        } else {
            this.dialogRef.close();
        }
    }

    isScholasticPeriodEnabled(checkInDate: any, semesterId: number, isActive: boolean, housingProgramId?: number) {
        return ((this.applicationHousingProgramId && housingProgramId && this.applicationHousingProgramId === housingProgramId) || (!this.applicationHousingProgramId && this.applicationScholasticPeriodId === semesterId)) || (isActive && (!this.currentUser.admissionsStartDate || new Date(checkInDate) >= new Date(this.currentUser.admissionsStartDate)) && !(this.isHousingProgramApplication && !housingProgramId && !!this.housingPrograms.find(f => f.scholasticPeriodId === semesterId)));
    }
}